export function adjustImageWidth(s7Image, imageSection, width, height) {
    if (!s7Image.includes('wid=') && !s7Image.includes('hei=')) {
        let offsetWidth = imageSection.current.offsetWidth;
        if (offsetWidth < width && offsetWidth > 0) {
            const calculatedHeight = Math.ceil((offsetWidth * height) / width);
            return {wid: offsetWidth, hei: calculatedHeight};
        }
    }
    return {wid: width, hei: height};
}

    function findGridColumnValue(element) {
        const regex = /aem-GridColumn--default--(\d+)/;
        const allClasses = [...element.classList].join(" ");
        const match = allClasses.match(regex);
        return match ? parseInt(match[1]) : null;
    }

    export function adjustDivHeight(imageSection, alignTo, imagePlacementMobile) {
        if (imageSection) {
            const parent = imageSection.parentNode;
						const grandParent = parent.parentNode;
						if(grandParent && imagePlacementMobile !== "default"){
							grandParent.classList.add("flex-container");
							if(imagePlacementMobile === "above"){
								parent.classList.add("image-placement-above");
								parent.classList.remove("image-placement-below");
							}
							if(imagePlacementMobile === "below"){
								parent.classList.add("image-placement-below");
								parent.classList.remove("image-placement-above");
							}
						}else{
							grandParent.classList.remove("flex-container");
							parent.classList.remove("image-placement-above");
							parent.classList.remove("image-placement-below");
						}
            if (parent) {
                const parentGridColumn = findGridColumnValue(parent);

                if (parentGridColumn < 12) {
                    const sibling = parent[alignTo];
                    if (sibling) {
                        return `${sibling.offsetHeight}px`;
                    }
                }
            }
        }
        return null;
    }
